/**
 * A group with several lists today (user, 19/10/2026: "the best N for
 * today"): one row per list under the group's Today row — its name, its own
 * verdict (each list is judged on its own drops) and its own sent · planned.
 * Only the lists a verdict judged (23/10/2026 — the Day timeline names the rest).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { DayPlanGroupRow, DropGenGroupVerdict } from '@trafficpulse/shared';

import { Badge, Tooltip } from '@/components/ui';

import type { DayPlanContainerRow } from '../../../drop-generator.types';
import { listCounts } from '../live-status';
import { actionCopy, VERDICT_TONE } from './verdict-copy';

const ROW = 'flex items-center gap-2 rounded-md px-2.5 py-1 text-xs';

export const TodayListRows: FC<{ container: DayPlanContainerRow; group: DayPlanGroupRow; verdicts?: DropGenGroupVerdict[] }> = ({ container, group, verdicts }) => (
  <>
    {(group.listsToday ?? []).map((list) => {
      const counts = listCounts(container, group.listGroupId, list.wiserId);
      const verdict = verdicts?.find((v) => v.listWiserId === list.wiserId);
      if (!verdict) return null;
      const action = actionCopy(verdict);
      return (
        <div key={list.wiserId} className={ROW} data-testid="today-list-row">
          <span className="w-11 shrink-0" />
          <span className="min-w-0 grow truncate font-mono">{list.name ?? `#${list.wiserId}`}</span>
          <Tooltip content={action ? `${verdict.reason} · ${action}` : verdict.reason}>
            <Badge tone={VERDICT_TONE[verdict.verdict] ?? 'secondary'}>{verdict.verdict.toLowerCase()}</Badge>
          </Tooltip>
          <span className="shrink-0 font-mono text-[11px] tabular-nums text-muted-foreground">
            {counts.sent} sent · {counts.planned - counts.sent} planned
          </span>
        </div>
      );
    })}
  </>
);
